import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DevicePingFilterDto } from '../components/SideComponents/status-history/status-history.component';
import appUrls from '../config/urls';

@Injectable({
  providedIn: 'root'
})
export class LineGraphService {

  graphurl = appUrls.lineDetails;
  accountUrl = appUrls.account;
  constructor(private http: HttpClient) { }

  getLineGraphDigestData(lineId: Number) {
    return this.http.get(this.graphurl.getLineGraphsReadings + lineId );
  }


  getDevicePingChangesLogs(deviceData: DevicePingFilterDto) {
    return this.http.post(this.graphurl.getDevicePingChangesLog, deviceData)
  }

  //getDevicePingChangesLogsById(deviceData: DevicePingFilterDto) {
  //  return this.http.post(this.graphurl.getDevicePingChangesLog, deviceData)
  //}

  getDevicePingResult(deviceIp: string, fromTime?: any, toTime?: any) {
    let object: DevicePingFilterDto = { deviceIp: deviceIp, fromDate: fromTime, toDate: toTime,  pairNumber: null };
    return this.http.post(this.graphurl.getDevicePingResult, object);

  }

  getLineGraphDataReadings(interfacesIds: number[], fromDate: Date, toDate: Date) {
    /* let isTotalBoolean: boolean = (istotal == "true") ? true : false;*/
    return this.http.post(this.graphurl.getlineGraph, { interfacsesIds: interfacesIds, fromTime: fromDate, toTime: toDate }); //, isTotalGraph: isTotalBoolean 
  }

  getLineGraphListData(lineId: Number, isTotalGraph: string) {
    let isTotalBoolean: boolean = (isTotalGraph == "true") ? true : false;
    return this.http.get(this.graphurl.getlineGraphList + lineId + '/' + isTotalGraph);
  }

  getgraphStatistics(interfacesIds: number[]) {
    let formData = new FormData();
    //interfacesIds.forEach(i => formData.append('ids', i.toString()))
    for (let i = 0; i < interfacesIds.length; i++) {
      formData.append("Ids", interfacesIds[i].toString());
    }
    return this.http.post(this.graphurl.getGraphStatistics, formData);

  }

  getAccountGraphs() {
   return this.http.get(this.accountUrl.getAccountTotalGraph);
  }

}
